import H5 from 'UIComponents/elements/headings/H5';
import styled from 'styled-components';
import { STANDARD_HEADER_TOP_MARGIN } from '../utils/spacing';
import MdxHeader from './MdxHeader';
import { jsx as _jsx } from "react/jsx-runtime";
const StyledH5 = styled(H5).withConfig({
  displayName: "MdxH5__StyledH5",
  componentId: "sc-1d5jdvr-0"
})(["margin-top:", ";"], STANDARD_HEADER_TOP_MARGIN);
function MdxH5(props) {
  return /*#__PURE__*/_jsx(MdxHeader, Object.assign({
    Component: StyledH5
  }, props));
}
export default MdxH5;